<template>
    <div class="item-row" :ref="'item-'+ route.id" style="position: relative;">

        <div  v-if="flightstatus === 'direct'">

            <div class="item-smallheader" style="background: #54b484;">
                <span>Direct</span> {{ convertMinutesToTime(route.duration, ' ') }}
            </div>

        </div>

        <div v-if="flightstatus === 'connection'">

            <div class="item-smallheader" style="background: #2c69b3;">
                <span>1 stop</span> {{ convertMinutesToTime(route.duration, ' ') }}
            </div>

        </div>

        <div v-if="flightstatus === 'other'"  >

            <div class="item-smallheader" style="background: #333;">
                <span>1 stop</span> {{ convertMinutesToTime(route.duration, ' ') }}
            </div>

        </div>

        <div class="main-info d-flex justify-content-between" :class="{'is-open': isOpen}" @click="toggleOpen">

            <div class="d-flex duration-time">

                <div class="airline-logo">

                    <div v-if="route.airline" class="image-container">
                        <img  class="single-logo" :src="'https://images.flig.ht/airlines/100/' + route.airline.IATA + '_100px.png'" :alt="route.airline.name">
                    </div>

                    <div v-else-if="route.l1_airline.name === route.l2_airline.name" class="image-container">
                        <img class="single-logo" :src="'https://images.flig.ht/airlines/100/' + route.l1_airline.IATA + '_100px.png'" :alt="route.l1_airline.name">
                    </div>

                    <div v-else style="position:relative;">

                        <div class="image-container">

                            <img class="first-logo" :src="'https://images.flig.ht/airlines/100/' + route.l1_airline.IATA + '_100px.png'" :alt="route.l1_airline.name">

                       </div>


                        <div class="image-container-second">

                            <img class="second-logo" :src="'https://images.flig.ht/airlines/100/' + route.l2_airline.IATA + '_100px.png'" :alt="route.l2_airline.name">

                        </div>

                    </div>

                </div>

                <div class="flight-info duration-container">

                    <div class="duration-bar-wrap">

                        <div class="line">

                            <ul class="duration-bar-list" v-if="route.is_direct">

                                <li class="odd odd-first odd-last background-normal" :style="'width:' + calculateWidth(route.duration) + '%'">

                                    <span class="halt-city">Direct</span>

                                    <span class="flight-duration">{{ convertMinutesToTime(route.duration) }}</span>

                                    <span class="from-code"><span class="code">{{ route.iata_from }}</span><span class="time">{{ convertTime(route.departure_time) }}</span></span>

                                    <span class="to-code"><span class="code">{{ route.iata_to }}</span><span class="time">{{ convertTime(route.arrival_time) }}</span></span>

                                </li>

                            </ul>



                            <ul class="duration-bar-list" v-else>

                                <li class="odd odd-first background-normal" :style="'width:' + calculateWidth(route.l1_flight_time) + '%'">

                                    <span class="flight-duration">

                                         <div v-if="route.l1_flight_time > 70">

                                            {{ convertMinutesToTime(route.l1_flight_time) }}

                                        </div>

                                    </span>

                                    <span class="from-code"><span class="code">{{ route.iata_from }}</span><span class="time">{{ convertTime(route.departure_time) }}</span></span>
                                </li>

                                <li class="even background-normal" :style="'width:' + calculateWidth(route.duration - (route.l1_flight_time + route.l2_flight_time)) + '%'">

                                    <span class="halt-city">

                                        Via <span class="show-desktop">{{ route.viaCity }}</span>
                                            <span class="show-mobile">{{ route.iata_via }}</span>

                                    </span>
                                    <!--  Kolla här om flighttime är över 70, för att visa den undre saken här  -->
                                    <span class="flight-duration halt">

                                        {{ convertMinutesToTime(route.duration - (route.l1_flight_time + route.l2_flight_time)) }}

                                    </span>





                                    <span class="halt-code"><img :alt="route.via_country_code" :src="'https://images.flig.ht/flags2/'+ route.via_country_code.toLowerCase() +'.svg'">

                                        <span class="halt-code-class">{{ route.iata_via }}</span>

                                    </span>

                                </li>

                                <li class="odd odd-last background-normal" :style="'width:' + calculateWidth(route.l2_flight_time) + '%'">

                                    <span class="flight-duration">{{ convertMinutesToTime(route.l2_flight_time) }}</span>

                                    <span class="to-code"><span class="code">{{ route.iata_to }}</span><span class="time">{{ convertTime(route.arrival_time) }}</span></span>

                                </li>

                            </ul>



                        </div>

                    </div>

                </div>

            </div>














            <div class="d-flex mobile-border">

                <div class="airline-logo-mobile">

                    <div v-if="route.airline" class="image-container">

                        <img class="single-logo" :src="'https://images.flig.ht/airlines/100/' + route.airline.IATA + '_100px.png'" :alt="route.airline.name">

                    </div>

                    <div v-else-if="route.l1_airline.name === route.l2_airline.name" class="image-container">

                        <div class="image-container">

                            <img class="single-logo" :src="'https://images.flig.ht/airlines/100/' + route.l1_airline.IATA + '_100px.png'" :alt="route.l1_airline.name">

                        </div>

                    </div>

                    <div v-else style="position: relative;">

                        <div class="image-container">

                            <img class="first-logo" :src="'https://images.flig.ht/airlines/100/' + route.l1_airline.IATA + '_100px.png'" :alt="route.l1_airline.name">

                        </div>


                        <div class="image-container-second">

                            <img class="second-logo" :src="'https://images.flig.ht/airlines/100/' + route.l2_airline.IATA + '_100px.png'" :alt="route.l2_airline.name">

                        </div>

                    </div>
                </div>
                <div class="info-block">
                    <div>
                        <div class="route-tooltip" v-if="!route.is_direct && route.duration - (route.l1_flight_time + route.l2_flight_time) > 180">
                            <span class="route-tooltiptext">Long layover time {{ convertMinutesToTime(route.duration - (route.l1_flight_time + route.l2_flight_time)) }}</span>
                            <i class="bi bi-hourglass-split"></i>
                        </div>
                        <div class="route-tooltip" v-if="route.is_terminal_change">
                            <span class="route-tooltiptext">Change from terminal {{ route.l1_arrival_terminal }} to terminal {{ route.l2_departure_terminal }}</span>
                            <i class="bi bi-exclamation-triangle"></i>
                        </div>
                        <div class="route-tooltip" v-if="isOverNight(route)">
                            <span class="route-tooltiptext">Overnight flight</span>
                            <i class="bi bi-moon-stars-fill"></i>
                        </div>
                        <div class="route-tooltip" v-if="isLowcost(route)">
                            <span class="route-tooltiptext">Low-cost airline</span>
                            <i class="bi bi-cash-coin"></i>
                        </div>
                        <div class="route-tooltip" v-if="route.is_codeshare">
                            <span class="route-tooltiptext">Codeshare flight</span>
                            <i class="bi bi-file-code-fill"></i>
                        </div>

                        <div class="route-tooltip">
                            <i class="bi bi-geo-alt"></i>
                         </div>

                    </div>
                    <div class="info-block-item">
                        <span class="bold-time">{{ route.is_direct ? 'Direct' : '1 stop' }}</span> {{ convertMinutesToTime(route.duration, ' ') }}
                    </div>
                </div>
                <div class="route-action">






                    <div v-if="isOpen == true">


                        <button style="white-space: nowrap; text-decoration: underline dotted; text-decoration-color: #9e9e9e; text-underline-offset: 3px;">
                            Close<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16"><path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg></button>


                    </div>
                    <div v-if="isOpen == false">

                        <button style="white-space: nowrap; text-decoration: underline dotted; text-decoration-color: #9e9e9e; text-underline-offset: 3px;" class="expand_button">Expand<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="down-arrow" fill="#2ea762"><path d="M17,9.17a1,1,0,0,0-1.41,0L12,12.71,8.46,9.17a1,1,0,0,0-1.41,0,1,1,0,0,0,0,1.42l4.24,4.24a1,1,0,0,0,1.42,0L17,10.59A1,1,0,0,0,17,9.17Z"></path></svg></button>

                    </div>









                </div>
            </div>
        </div>


        <div v-if="isOpen">

            <div class="more-info-with-map">

                <div class="more-info-block">







<!-- DIRECT FLIGHT  -->



                    <div class="detailed-info">

                        <template v-if="route.is_direct">

                            <ul class="timeline-vertical">

                                <li class="timeline-item departure">

                                    <div class="flight-point-info">

                                        <span class="time-and-city">{{ routeData.departure_time.slice(0,-3) }} {{ routeData.airport_from.city_name_en }}</span>
                                        <span class="airport-name-iata">{{ routeData.airport_from.local_name ?? routeData.airport_from.name }} <strong>{{ routeData.airport_from.IATA }}</strong></span>

                                    </div>
                                </li>
                                <li class="aircraft-info-item" style="padding-top: 10px; padding-bottom: 10px;">

                                    <div class="line-aircraft">
                                        <svg fill="#000000" width="22px"  viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg"><path d="M 54.4141 28 C 54.3906 25.2578 50.6639 23.2656 46.1874 23.2656 L 36.7421 23.2656 C 35.4296 23.2656 34.9374 23.0547 34.1640 22.1641 L 18.4140 4.9844 C 17.9218 4.4219 17.3124 4.1406 16.6093 4.1406 L 13.8905 4.1406 C 13.2812 4.1406 12.9296 4.6797 13.2343 5.3359 L 21.3437 23.2656 L 9.4374 24.6250 L 5.1952 16.8437 C 4.8905 16.2578 4.3749 16 3.6015 16 L 2.5937 16 C 1.9843 16 1.5859 16.3984 1.5859 17.0078 L 1.5859 38.9922 C 1.5859 39.6016 1.9843 39.9766 2.5937 39.9766 L 3.6015 39.9766 C 4.3749 39.9766 4.8905 39.7188 5.1952 39.1563 L 9.4374 31.3750 L 21.3437 32.7344 L 13.2343 50.6641 C 12.9296 51.2968 13.2812 51.8594 13.8905 51.8594 L 16.6093 51.8594 C 17.3124 51.8594 17.9218 51.5547 18.4140 51.0156 L 34.1640 33.8125 C 34.9374 32.9453 35.4296 32.7344 36.7421 32.7344 L 46.1874 32.7344 C 50.6639 32.7344 54.3906 30.7188 54.4141 28 Z"/></svg>
                                    </div>

                                    <div class="flight-duration-info">

                                        <div style="display: flex; flex-direction: row; align-items: center; background-color:#f0f0f0; padding-left: 10px; padding-right: 10px; padding-top: 5px; padding-bottom: 5px; border-radius: 5px;">

                                            <div style="margin-right: 10px;">

                                                <img class="carrier-logo" style="width: 35px; border-radius: 3px;" :src="'https://images.flig.ht/airlines/100/' + routeData.carrier + '_100px.png'" :alt="routeData.airline.name">

                                            </div>

                                            <div>

                                                <div><strong>{{ convertMinutesToTime(routeData.elapsed_time) }}</strong></div>

                                                <Popper class="theme" arrow placement="top">

                                                        <template #content>

                                                            <div style="margin-bottom: 5px;">

                                                                <img class="carrier-logo" style="width: 15px; border-radius: 3px; margin-right: 5px;" :src="'https://images.flig.ht/airlines/100/' + routeData.carrier + '_100px.png'" :alt="routeData.airline.name">

                                                                <strong>{{ routeData.airline.name }}</strong>  {{ routeData.carrier }}{{routeData.flightnumber}}

                                                            </div>

                                                            <div>

                                                                {{ routeData.flight_distance_mi }}mi - {{ routeData.flight_distance_km }}km

                                                            </div>


                                                        </template>

                                                        <button style="border: 0; padding: 0; background-color:transparent; font-size: 13px; text-decoration: underline dotted rgb(158, 158, 158); text-underline-offset: 3px;">
                                                            {{ routeData.carrier }}{{routeData.flightnumber}}<br />
                                                        </button>
                                                    </Popper>


                                                <span class="red-notice" v-if="isFlightOvernight(routeData.departure_time.slice(0,-3),routeData.arrival_time.slice(0,-3), routeData.elapsed_time)">Overnight flight</span>

                                            </div>

                                        </div>
                                   </div>

                                </li>






<!-- one-stop flight -->




                                <li class="timeline-item arrival">

                                    <div class="flight-point-info bottom">

                                        <span class="time-and-city">{{ routeData.arrival_time.slice(0,-3) }} {{ routeData.airport_to.city_name_en }}</span>

                                        <span class="airport-name-iata">{{ routeData.airport_to.local_name ?? routeData.airport_to.name }} <strong>{{ routeData.airport_to.IATA }}</strong></span>

                                    </div>

                                </li>
                            </ul>
                        </template>
                        <template v-else>
                            <ul class="timeline-vertical">
                                <li class="timeline-item departure">
                                    <div class="flight-point-info">
                                        <span class="time-and-city">{{ routeData.l1_departure_time.slice(0,-3) }} {{ routeData.airport_from.city_name_en }}</span>
                                        <span class="airport-name-iata">{{ routeData.airport_from.local_name ?? routeData.airport_from.name }} <strong>{{ routeData.airport_from.IATA }}</strong><template v-if="routeData.l1_departure_terminal">, Terminal {{routeData.l1_departure_terminal}}</template></span>
                                    </div>
                                </li>
                                <li class="aircraft-info-item">

                                    <div class="line-aircraft">
                                        <svg fill="#000000" width="22px"  viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg"><path d="M 54.4141 28 C 54.3906 25.2578 50.6639 23.2656 46.1874 23.2656 L 36.7421 23.2656 C 35.4296 23.2656 34.9374 23.0547 34.1640 22.1641 L 18.4140 4.9844 C 17.9218 4.4219 17.3124 4.1406 16.6093 4.1406 L 13.8905 4.1406 C 13.2812 4.1406 12.9296 4.6797 13.2343 5.3359 L 21.3437 23.2656 L 9.4374 24.6250 L 5.1952 16.8437 C 4.8905 16.2578 4.3749 16 3.6015 16 L 2.5937 16 C 1.9843 16 1.5859 16.3984 1.5859 17.0078 L 1.5859 38.9922 C 1.5859 39.6016 1.9843 39.9766 2.5937 39.9766 L 3.6015 39.9766 C 4.3749 39.9766 4.8905 39.7188 5.1952 39.1563 L 9.4374 31.3750 L 21.3437 32.7344 L 13.2343 50.6641 C 12.9296 51.2968 13.2812 51.8594 13.8905 51.8594 L 16.6093 51.8594 C 17.3124 51.8594 17.9218 51.5547 18.4140 51.0156 L 34.1640 33.8125 C 34.9374 32.9453 35.4296 32.7344 36.7421 32.7344 L 46.1874 32.7344 C 50.6639 32.7344 54.3906 30.7188 54.4141 28 Z"/></svg>
                                    </div>

                                    <div class="flight-duration-info">
                                        <!-- FIRST LEG -->
                                        <div style="display: flex; flex-direction: row; align-items: center; background-color:#f0f0f0; padding-left: 10px; padding-right: 10px; padding-top: 5px; padding-bottom: 5px; border-radius: 5px;">

                                            <div style="margin-right: 10px;">

                                                <img class="carrier-logo" style="width: 35px; border-radius: 3px;" :src="'https://images.flig.ht/airlines/100/' + routeData.l1_carrier + '_100px.png'" :alt="routeData.first_airline.name">

                                            </div>

                                            <div>

                                                <div>

                                                    <div style="font-size: 14px;"><strong>{{ convertMinutesToTimeLong(routeData.l1_flight_time) }}</strong></div>

                                                </div>

                                                <div class="distance">

                                                    <Popper class="theme" arrow placement="top">

                                                        <template #content>

                                                            <div style="font-size: 12px;">

                                                                <div style="margin-bottom: 5px;">
                                                                    <img class="carrier-logo" style="width: 15px; border-radius: 3px; margin-right: 5px;" :src="'https://images.flig.ht/airlines/100/' + routeData.l1_carrier + '_100px.png'" :alt="routeData.first_airline.name">
                                                                    <strong>{{ routeData.first_airline.name }}</strong> {{ routeData.l1_carrier }}{{routeData.l1_flightnumber}}
                                                                </div>
                                                                <div>{{ routeData.l1_flight_distance_mi }}mi - {{ routeData.l1_flight_distance_km }}km</div>
                                                                <div class="codeshare" v-if="routeData.l1_is_codeshare">Codeshare, actual flight is {{ routeData.l1_operating_carrier }}</div>
                                                                <div>{{ routeData.first_aircraft.name }}, {{ routeData.first_schedule.seats_total }} seats</div>
                                                                <div v-if="routeData.first_schedule.tag" v-html="routeData.first_schedule.tag"></div>
                                                                <div>Classes: {{ routeData.l1_classes }}</div>

                                                            </div>

                                                        </template>

                                                        <button style="border: 0; padding: 0; background-color:transparent; font-size: 13px; text-decoration: underline dotted rgb(158, 158, 158); text-underline-offset: 3px;">{{ routeData.l1_carrier }}{{routeData.l1_flightnumber}}</button>
                                                    </Popper>




                                                    <span class="codeshare-flight" v-if="routeData.l1_is_codeshare">CODESHARE FLIGHT</span>

                                                    <span class="red-notice" v-if="isFlightOvernight(routeData.l1_departure_time.slice(0,-3),routeData.l1_arrival_time.slice(0,-3), routeData.l1_flight_time)">Overnight flight</span>

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </li>












                                <li class="timeline-item arrival">
                                    <div class="flight-point-info bottom">

                                        <span class="time-and-city">{{ routeData.l1_arrival_time.slice(0,-3) }} {{ routeData.airport_via.city_name_en }}

                                        <span class="red-notice" v-if="isArrivesNextDay()">Arrives at {{ nextDay }}</span></span>

                                        <span class="airport-name-iata">{{ routeData.airport_via.local_name ?? routeData.airport_via.name }} <strong>{{ routeData.airport_via.IATA }}</strong><template v-if="routeData.l1_arrival_terminal">, Terminal {{routeData.l1_arrival_terminal}}</template></span>

                                    </div>
                                </li>
                                <li class="timeline-item layover">

                                    <div class="layover-overlay"></div>

                                    <div style="padding-top: 6px; padding-bottom: 0px;">

                                        <!-- Layover time -->

                                        <Popper class="theme" arrow placement="top">

                                            <template #content>


                                                <span style="font-size: 12px; display: block;">

                                                    <span style="margin-bottom: 5px; display: block;"><strong>Layover airport</strong></span>

                                                    <span style="display: block;">{{routeData.airport_via.IATA}} {{ routeData.airport_via.name }} </span>


                                                    <span v-if="routeData.l1_arrival_terminal != ''" style="display: block;">Arrival terminal: {{ routeData.l1_arrival_terminal }}</span>

                                                    <span v-if="routeData.l2_departure_terminal != ''" style="display: block;">Departing terminal: {{ routeData.l2_departure_terminal }}</span>



                                                    <span style="display: block;" v-if="routeData.hub">
                                                        <span class="codeshare">{{ routeData.hub.airport }} is a {{ routeData.hub.airline.name }} hub <span v-if="routeData.hub.hub_comment">({{ routeData.hub.hub_comment }})</span></span>
                                                    </span>

                                                </span>

                                            </template>

                                            <span style="font-size: 12px; display: block; min-height: 0;">

                                                <span style="font-size: 16px; font-weight: 400; display: inline-block; margin-right: 5px;">Layover time at </span>

                                                <button style="display: inline-block; margin-right: 5px; border: 0; padding: 0; background-color:transparent; font-size: 16px; font-weight: 400; text-decoration: underline dotted rgb(158, 158, 158); text-underline-offset: 3px;">

                                                     {{ routeData.iata_via }}:

                                                </button>

                                                <span style="font-size: 16px; font-weight: 400; display: inline; margin-left: 5px;"> <strong>{{ convertMinutesToTime(routeData.l1_layover_time) }}</strong></span>

                                                <span class="red-notice" style="display: inline-block;" v-if="showChangeTerminal()">Terminal change</span>

                                                <span class="red-notice" style="display: inline-block;" v-if="routeData.l1_layover_time > 180" >Long layover time</span>

                                            </span>

                                        </Popper>

                                    </div>

                                </li>




                                <li class="timeline-item departure">

                                    <div class="flight-point-info">

                                        <span class="time-and-city">{{ routeData.l2_departure_time.slice(0,-3) }} {{ routeData.airport_via.city_name_en }}</span>

                                        <span class="airport-name-iata">{{ routeData.airport_via.local_name ?? routeData.airport_via.name }} <strong>{{ routeData.airport_via.IATA }}</strong>
                                        <template v-if="routeData.l2_departure_terminal">, Terminal {{routeData.l2_departure_terminal}}</template></span>

                                    </div>
                                </li>
                                <li class="aircraft-info-item">
                                    <div class="flight-duration-info">

                                        <div class="line-aircraft">
                                            <svg fill="#000000" width="22px"  viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg"><path d="M 54.4141 28 C 54.3906 25.2578 50.6639 23.2656 46.1874 23.2656 L 36.7421 23.2656 C 35.4296 23.2656 34.9374 23.0547 34.1640 22.1641 L 18.4140 4.9844 C 17.9218 4.4219 17.3124 4.1406 16.6093 4.1406 L 13.8905 4.1406 C 13.2812 4.1406 12.9296 4.6797 13.2343 5.3359 L 21.3437 23.2656 L 9.4374 24.6250 L 5.1952 16.8437 C 4.8905 16.2578 4.3749 16 3.6015 16 L 2.5937 16 C 1.9843 16 1.5859 16.3984 1.5859 17.0078 L 1.5859 38.9922 C 1.5859 39.6016 1.9843 39.9766 2.5937 39.9766 L 3.6015 39.9766 C 4.3749 39.9766 4.8905 39.7188 5.1952 39.1563 L 9.4374 31.3750 L 21.3437 32.7344 L 13.2343 50.6641 C 12.9296 51.2968 13.2812 51.8594 13.8905 51.8594 L 16.6093 51.8594 C 17.3124 51.8594 17.9218 51.5547 18.4140 51.0156 L 34.1640 33.8125 C 34.9374 32.9453 35.4296 32.7344 36.7421 32.7344 L 46.1874 32.7344 C 50.6639 32.7344 54.3906 30.7188 54.4141 28 Z"/></svg>
                                        </div>


                                        <!-- SECOND LEG -->


                                        <div style="display: flex; flex-direction: row; align-items: center; background-color:#f0f0f0; padding-left: 10px; padding-right: 10px; padding-top: 5px; padding-bottom: 5px; border-radius: 5px;">

                                            <div style="margin-right: 10px;">

                                                <img class="carrier-logo" style="width: 35px; border-radius: 3px;" :src="'https://images.flig.ht/airlines/100/' + routeData.l2_carrier + '_100px.png'" :alt="routeData.second_airline.name">


                                            </div>

                                            <div>

                                                <div style="font-size: 14px;"><strong>{{ convertMinutesToTimeLong(routeData.l2_flight_time) }}</strong></div>

                                                <Popper class="theme" arrow placement="top">

                                                        <template #content>

                                                            <div style="font-size: 12px;">

                                                                <div style="margin-bottom: 5px;">

                                                                    <img class="carrier-logo" style="width: 15px; border-radius: 3px; margin-right: 5px;" :src="'https://images.flig.ht/airlines/100/' + routeData.l2_carrier + '_100px.png'" :alt="routeData.second_airline.name"> <strong>{{ routeData.second_airline.name }}</strong> {{ routeData.l2_carrier }}{{routeData.l2_flightnumber}}

                                                                </div>

                                                                <div>{{ routeData.l2_flight_distance_mi }}mi - {{ routeData.l2_flight_distance_km }}km</div>

                                                                <div class="codeshare" v-if="routeData.l2_is_codeshare">Codeshare, actual flight is {{ routeData.l2_operating_carrier }}</div>
                                                                <div>{{ routeData.second_aircraft.name }}, {{ routeData.second_schedule.seats_total }} seats</div>
                                                                <div v-if="routeData.second_schedule.tag" v-html="routeData.second_schedule.tag"></div>
                                                                <div>Classes: {{ routeData.l2_classes }}</div>

                                                            </div>

                                                        </template>

                                                        <button style="border: 0; padding: 0; background-color:transparent; font-size: 13px; text-decoration: underline dotted rgb(158, 158, 158); text-underline-offset: 3px;">{{ routeData.l2_carrier }}{{routeData.l2_flightnumber}}</button>

                                                    </Popper>





                                                    <span class="codeshare-flight" v-if="routeData.l2_is_codeshare">CODESHARE FLIGHT</span>

                                                <span class="red-notice" v-if="isFlightOvernight(routeData.l2_departure_time.slice(0,-3),routeData.l2_arrival_time.slice(0,-3), routeData.l2_flight_time)">Overnight flight</span>


                                            </div>

                                        </div>

                                    </div>

                                </li>

                                <li class="timeline-item arrival">

                                    <div class="flight-point-info bottom">

                                        <span class="time-and-city">{{ routeData.l2_arrival_time.slice(0,-3) }} {{ routeData.airport_to.city_name_en }}

                                            <span class="red-notice" v-if="isArrivesNextDay()">Arrives at {{ nextDay }}</span></span>

                                            <span class="airport-name-iata">{{ routeData.airport_to.local_name ?? routeData.airport_to.name }} <strong>{{ routeData.airport_to.IATA }}</strong>

                                            <template v-if="routeData.l2_arrival_terminal">, Terminal {{routeData.l2_arrival_terminal}}</template>
                                        </span>
                                    </div>
                                </li>
                            </ul>
                        </template>
                    </div>
                </div>
                <div class="map">

                    <div style="position: relative; height: 320px; max-height: 320px; overflow: hidden; margin-left: 10px; margin-top: 10px; margin-right: 10px; border-radius :7px;">

                        <div style="position: absolute; top: 10px;  z-index: 500; left: 0; right: 0; font-size: 16px; color:#666; text-align: center;">

                            <div style="display: inline-block; padding: 5px 20px; background-color:#fff; border-radius: 5px;">
                                <strong>Total flight time:</strong>{{ convertMinutesToTime(route.duration, ' ') }}
                            </div>

                        </div>

                        <interactive-map :route-json="routeJson" :component-height="'400px'" theme-name="flight" id="interactiveMap" selectable-airport="true"></interactive-map>

                    </div>


                    <div style="text-align: right; margin-top: 10px;" class="sc-buttons-wrapper">
                        <button class="btn btn-secondary me-2 sch-buttons" data-bs-toggle="modal" data-bs-target="#outbounds" @click.prevent="openModal('cars')">CAR RENTAL</button>
                        <button class="btn btn-secondary me-2 sch-buttons" data-bs-toggle="modal" data-bs-target="#outbounds" @click.prevent="openModal('hotels')">TOP HOTELS</button>
                        <button class="button-six btn sch-buttons" data-bs-toggle="modal" data-bs-target="#outbounds" @click.prevent="openModal('availability')">CHECK AVAILABILITY</button>
                    </div>

                </div>

            </div>
            <!--
            <div class="action-footer d-flex justify-content-center justify-content-lg-end">
                <button class="btn btn-secondary me-2" @click.prevent="openModal('cars')">CAR RENTAL</button>
                <button class="btn btn-secondary me-2" @click.prevent="openModal('hotels')">TOP HOTELS</button>
                <button class="button-six btn" @click.prevent="openModal('availability')">CHECK AVAILABILITY</button>
            </div>
        -->
        </div>

        <div v-if="loading" class="loading">Loading&#8230;</div>
        <div class="modal fade" id="outbounds" data-bs-backdrop="true" data-bs-keyboard="true" tabindex="-1">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <div>{{ route.from }} ({{ route.iata_from }}) to {{ route.to }} ({{ route.iata_to }}) on {{ currentDate }}</div>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        Open with:
                        <div>
                            <div class="vendors-button" @click="goKayak(route.iata_from, route.iata_to, routeData.date_from, route.to, route.country_to, 'kayak')">
                                <svg height="40px" viewBox="0 0 125 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" style="width:inherit;height:inherit;line-height:inherit;color:inherit"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 24h23.936V0H0v24zm25.266 0h23.936V0H25.266v24zm49.202 0H50.532V0h23.936v24zm1.33 0h23.936V0H75.798v24zM125 24h-23.936V0H125v24z" fill="#FF690F"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M10.287 11.549V6H7.38v12h2.907v-5.548L13.348 18h3.208l-3.33-6 3.33-6h-3.208l-3.061 5.549zm24.785 4.724L34.552 18h-3.104l3.947-12h3.696l3.93 12h-3.194l-.52-1.727h-4.235zm2.117-6.837l-1.4 4.48h2.8l-1.4-4.48zM63.98 18h-2.906v-5.29L57.144 6h3.463l1.938 3.688L64.447 6h3.409l-3.876 6.71V18zm21.624-1.727L85.084 18h-3.105l3.948-12h3.696l3.93 12h-3.194l-.52-1.727h-4.235zm2.117-6.837l-1.4 4.48h2.8l-1.4-4.48zm23.63 2.113V6h-2.907v12h2.907v-5.548L114.412 18h3.208l-3.33-6 3.33-6h-3.208l-3.061 5.549z" fill="#FAFAFC"></path> </svg>
                            </div>
                            <div class="vendors-button" v-if="modalType !== 'hotels'" @click="goKayak(route.iata_from, route.iata_to, routeData.date_from, route.to, route.country_to, 'momondo')">
                                <svg height="30px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250 38" role="img" style="position: relative; top: -2px; width:inherit;height:inherit;line-height:inherit;color:inherit"><defs><linearGradient id="logos806a-1" x2="0" y2="100%"><stop offset="0" stop-color="#00d7e5"></stop><stop offset="1" stop-color="#0066ae"></stop></linearGradient><linearGradient id="logos806b-1" x2="0" y2="100%"><stop offset="0" stop-color="#ff30ae"></stop><stop offset="1" stop-color="#d1003a"></stop></linearGradient><linearGradient id="logos806c-1" x2="0" y2="100%"><stop offset="0" stop-color="#ffba00"></stop><stop offset="1" stop-color="#f02e00"></stop></linearGradient></defs><path fill="url(#logos806a-1)" d="M23.2 15.5c2.5-2.7 6-4.4 9.9-4.4 8.7 0 13.4 6 13.4 13.4v12.8c0 .3-.3.5-.5.5h-6c-.3 0-.5-.2-.5-.5V24.5c0-4.6-3.1-5.9-6.4-5.9-3.2 0-6.4 1.3-6.4 5.9v12.8c0 .3-.3.5-.5.5h-5.9c-.3 0-.5-.2-.5-.5V24.5c0-4.6-3.1-5.9-6.4-5.9-3.2 0-6.4 1.3-6.4 5.9v12.8c0 .3-.3.5-.5.5h-6c-.3 0-.5-.2-.5-.5V24.5c0-7.4 4.7-13.4 13.3-13.4 4 0 7.5 1.7 9.9 4.4m54.3 9.1c0 7.5-5.2 13.4-14 13.4s-14-5.9-14-13.4c0-7.6 5.2-13.4 14-13.4 8.8-.1 14 5.9 14 13.4zm-6.7 0c0-3.7-2.4-6.8-7.3-6.8-5.2 0-7.3 3.1-7.3 6.8 0 3.7 2.1 6.8 7.3 6.8 5.1-.1 7.3-3.1 7.3-6.8z"></path><path fill="url(#logos806b-1)" d="M103.8 15.5c2.5-2.7 6-4.4 9.9-4.4 8.7 0 13.4 6 13.4 13.4v12.8c0 .3-.3.5-.5.5h-5.9c-.3 0-.5-.2-.5-.5V24.5c0-4.6-3.1-5.9-6.4-5.9-3.2 0-6.4 1.3-6.4 5.9v12.8c0 .3-.3.5-.5.5H101c-.3 0-.5-.2-.5-.5V24.5c0-4.6-3.1-5.9-6.4-5.9-3.2 0-6.4 1.3-6.4 5.9v12.8c0 .3-.3.5-.5.5h-5.9c-.3 0-.5-.2-.5-.5V24.5c0-7.4 4.7-13.4 13.3-13.4 3.8 0 7.3 1.7 9.7 4.4m54.3 9.1c0 7.5-5.2 13.4-14 13.4s-14-5.9-14-13.4c0-7.6 5.2-13.4 14-13.4 8.7-.1 14 5.9 14 13.4zm-6.7 0c0-3.7-2.3-6.8-7.3-6.8-5.2 0-7.3 3.1-7.3 6.8 0 3.7 2.1 6.8 7.3 6.8 5.1-.1 7.3-3.1 7.3-6.8zm9.8-.1v12.8c0 .3.2.5.5.5h5.9c.3 0 .5-.2.5-.5V24.5c0-4.6 3.1-5.9 6.4-5.9 3.3 0 6.4 1.3 6.4 5.9v12.8c0 .3.2.5.5.5h5.9c.3 0 .5-.2.5-.5V24.5c0-7.4-4.5-13.4-13.4-13.4-8.7 0-13.2 6-13.2 13.4"></path><path fill="url(#logos806c-1)" d="M218.4 0h-5.9c-.3 0-.5.2-.5.5v13c-1.3-1.2-4.3-2.4-7-2.4-8.8 0-14 5.9-14 13.4s5.2 13.4 14 13.4c8.7 0 14-5.2 14-14.6V.4c-.1-.2-.3-.4-.6-.4zm-13.5 31.3c-5.2 0-7.3-3-7.3-6.8 0-3.7 2.1-6.8 7.3-6.8 4.9 0 7.3 3 7.3 6.8s-2.2 6.8-7.3 6.8zM236 11.1c-8.8 0-14 5.9-14 13.4s5.2 13.4 14 13.4 14-5.9 14-13.4c0-7.4-5.3-13.4-14-13.4zm0 20.2c-5.2 0-7.3-3.1-7.3-6.8 0-3.7 2.1-6.8 7.3-6.8 4.9 0 7.3 3.1 7.3 6.8 0 3.8-2.2 6.8-7.3 6.8z"></path></svg>
                            </div>
                            <div class="vendors-button" v-if="modalType === 'hotels'" @click.prevent="goBooking(routeData.airport_to.city_name_en, route.iata_to, routeData.airport_to.dest_id)">
                                <svg height="35px" viewBox="0 0 460 78" fill="none" xmlns="http://www.w3.org/2000/svg" style="top: 3px; position: relative;">
                                    <g clip-path="url(#clip0_1_2)">
                                        <mask id="mask0_1_2" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="-1" width="460" height="79">
                                            <path d="M0.969177 -0.560015H459.13V77.1301H0.969177V-0.560015Z" fill="white"/>
                                        </mask>
                                        <g mask="url(#mask0_1_2)">
                                            <mask id="mask1_1_2" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="-1" width="460" height="79">
                                                <path d="M0.969849 77.1302H459.131V-0.55993H0.969849V77.1302Z" fill="white"/>
                                            </mask>
                                            <g mask="url(#mask1_1_2)">
                                                <path d="M180.639 7.94465C180.639 4.08823 183.754 0.969061 187.588 0.969061C191.435 0.969061 194.562 4.08823 194.562 7.94465C194.562 11.7961 191.435 14.9185 187.588 14.9185C183.754 14.9185 180.639 11.7961 180.639 7.94465Z" fill="#273B7D"/>
                                                <path d="M290.484 54.3422C290.484 50.4841 293.597 47.3616 297.431 47.3616C301.277 47.3616 304.403 50.4841 304.403 54.3422C304.403 58.1903 301.277 61.3161 297.431 61.3161C293.597 61.3161 290.484 58.1903 290.484 54.3422Z" fill="#499FDD"/>
                                                <path d="M66.3808 51.3271C60.385 51.3271 56.2183 46.5682 56.2183 39.7678C56.2183 32.9691 60.385 28.2135 66.3808 28.2135C72.4111 28.2135 76.6236 32.9691 76.6236 39.7678C76.6236 46.6756 72.4988 51.3271 66.3808 51.3271ZM66.3808 18.0543C53.6959 18.0543 44.49 27.1886 44.49 39.7678C44.49 52.347 53.6959 61.4797 66.3808 61.4797C79.1133 61.4797 88.3575 52.347 88.3575 39.7678C88.3575 27.1886 79.1133 18.0543 66.3808 18.0543Z" fill="#273B7D"/>
                                                <path d="M167.156 40.8538C166.663 39.9265 166.097 39.1413 165.495 38.5182L165.112 38.1115L165.515 37.7247C166.098 37.1115 166.693 36.3842 167.267 35.5412L178.461 18.9105H164.872L156.461 31.9195C155.985 32.617 155.024 32.9691 153.585 32.9691H151.668V8.37443C151.668 3.45516 148.601 2.78569 145.289 2.78569H139.617L139.627 60.84H151.668V43.4259H152.796C154.168 43.4259 155.103 43.5846 155.532 44.33L162.174 56.8596C164.03 60.2598 165.879 60.84 169.358 60.84H178.585L171.713 49.4791L167.156 40.8538Z" fill="#273B7D"/>
                                                <path d="M225.612 17.9617C219.487 17.9617 215.579 20.6808 213.389 22.9801L212.658 23.719L212.4 22.714C211.756 20.2511 209.588 18.8956 206.325 18.8956H200.928L200.962 60.8251H212.921V41.5001C212.921 39.6108 213.167 37.971 213.667 36.4751C214.998 31.9475 218.711 29.1325 223.353 29.1325C227.086 29.1325 228.544 31.1012 228.544 36.1891V54.4512C228.544 58.7936 230.554 60.8251 234.902 60.8251H240.594L240.575 34.1576C240.575 23.562 235.4 17.9617 225.612 17.9617Z" fill="#273B7D"/>
                                                <path d="M187.747 18.9138H182.078L182.117 51.3337L182.113 60.835H188.164C188.24 60.835 188.301 60.8433 188.377 60.8433L191.195 60.835H194.001V60.8186H194.02L194.044 25.2795C194.044 20.9917 191.989 18.9138 187.747 18.9138Z" fill="#273B7D"/>
                                                <path d="M113.356 51.3271C107.361 51.3271 103.186 46.5682 103.186 39.7678C103.186 32.9691 107.361 28.2135 113.356 28.2135C119.374 28.2135 123.598 32.9691 123.598 39.7678C123.598 46.6756 119.474 51.3271 113.356 51.3271ZM113.356 18.0543C100.658 18.0543 91.4506 27.1886 91.4506 39.7678C91.4506 52.347 100.658 61.4797 113.356 61.4797C126.075 61.4797 135.335 52.347 135.335 39.7678C135.335 27.1886 126.075 18.0543 113.356 18.0543Z" fill="#273B7D"/>
                                            </g>
                                        </g>
                                        <mask id="mask2_1_2" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="-1" width="460" height="79">
                                            <path d="M0.969177 -0.560015H459.13V77.1301H0.969177V-0.560015Z" fill="white"/>
                                        </mask>
                                        <g mask="url(#mask2_1_2)">
                                            <mask id="mask3_1_2" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="460" height="78">
                                                <path d="M0.96965 0.969054H459.033V77.031H0.96965V0.969054Z" fill="white"/>
                                            </mask>
                                            <g mask="url(#mask3_1_2)">
                                                <mask id="mask4_1_2" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="-1" width="460" height="79">
                                                    <path d="M0.96965 77.1302H459.13V-0.559945H0.96965V77.1302Z" fill="white"/>
                                                </mask>
                                                <g mask="url(#mask4_1_2)">
                                                    <path d="M369.705 51.3271C363.712 51.3271 359.534 46.5682 359.534 39.7678C359.534 32.9691 363.712 28.2135 369.705 28.2135C375.724 28.2135 379.95 32.9691 379.95 39.7678C379.95 46.6756 375.824 51.3271 369.705 51.3271ZM369.705 18.0543C357.01 18.0543 347.802 27.1886 347.802 39.7678C347.802 52.347 357.01 61.4797 369.705 61.4797C382.426 61.4797 391.683 52.347 391.683 39.7678C391.683 27.1886 382.426 18.0543 369.705 18.0543Z" fill="#499FDD"/>
                                                    <path d="M265.791 49.4824C259.253 49.4824 256.926 43.7813 256.926 38.4388C256.926 36.085 257.521 28.4135 265.163 28.4135C268.961 28.4135 274.022 29.5012 274.022 38.8339C274.022 47.636 269.543 49.4824 265.791 49.4824ZM280.231 18.8014C277.961 18.8014 276.215 19.7056 275.34 21.3569L275.009 21.9983L274.455 21.5173C272.524 19.8477 269.063 17.8675 263.443 17.8675C252.26 17.8675 244.731 26.2613 244.731 38.7529C244.731 51.2296 252.521 59.9491 263.668 59.9491C267.475 59.9491 270.484 59.0614 272.869 57.2564L273.792 56.5638V57.7291C273.792 63.3294 270.168 66.4188 263.598 66.4188C260.406 66.4188 257.5 65.642 255.557 64.9378C253.019 64.1724 251.532 64.8055 250.503 67.3495L249.554 69.6967L248.211 73.125L249.043 73.568C253.247 75.7979 258.721 77.1285 263.668 77.1285C273.853 77.1285 285.745 71.9183 285.745 57.2564L285.789 18.8014H280.231Z" fill="#273B7D"/>
                                                </g>
                                            </g>
                                        </g>
                                        <mask id="mask5_1_2" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="-1" width="460" height="79">
                                            <path d="M0.969177 -0.560015H459.13V77.1301H0.969177V-0.560015Z" fill="white"/>
                                        </mask>
                                        <g mask="url(#mask5_1_2)">
                                            <mask id="mask6_1_2" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="-1" width="460" height="79">
                                                <path d="M0.969849 77.1302H459.131V-0.55993H0.969849V77.1302Z" fill="white"/>
                                            </mask>
                                            <g mask="url(#mask6_1_2)">
                                                <path d="M21.8413 50.8461L12.1061 50.8364V39.2044C12.1061 36.7183 13.0704 35.4257 15.2022 35.1282H21.8413C26.58 35.1282 29.6418 38.1151 29.6452 42.9467C29.6418 47.9057 26.6561 50.8428 21.8413 50.8461ZM12.1061 19.4675V16.4062C12.1061 13.7268 13.2406 12.4523 15.7301 12.2887H20.7115C24.9838 12.2887 27.5427 14.8442 27.5427 19.1188C27.5427 22.3785 25.7911 26.182 20.8687 26.182H12.1061V19.4675ZM34.2747 31.0764L32.5146 30.088L34.051 28.7755C35.8376 27.2399 38.833 23.7885 38.833 17.8245C38.833 8.70003 31.7508 2.81045 20.7894 2.81045H8.28021L6.85597 2.80715C3.60619 2.9262 1.00602 5.56763 0.969658 8.83559V60.6284H6.71038C6.72493 60.6317 6.7298 60.6284 6.73465 60.6317L21.0365 60.6284C33.2216 60.6284 41.0864 54 41.0864 43.7333C41.0864 38.2058 38.547 33.4799 34.2747 31.0764Z" fill="#273B7D"/>
                                                <path d="M445.106 18.0973C440.144 18.0973 435.347 20.4197 432.267 24.3141L431.401 25.4117L430.721 24.1835C428.506 20.1469 424.694 18.0973 419.393 18.0973C413.834 18.0973 410.105 21.1966 408.373 23.0396L407.24 24.2662L406.804 22.6529C406.172 20.3304 404.103 19.051 400.969 19.051H395.942L395.893 60.8185H407.315V42.3812C407.315 40.7662 407.515 39.1678 407.92 37.4966C409.012 33.0419 412.007 28.2499 417.044 28.7292C420.15 29.0268 421.666 31.4252 421.666 36.0585V60.8185H433.168V42.3812C433.168 40.3629 433.357 38.8521 433.812 37.3363C434.738 33.0832 437.866 28.7226 442.725 28.7226C446.241 28.7226 447.542 30.7128 447.542 36.0585V54.7124C447.542 58.9325 449.425 60.8185 453.645 60.8185H459.021L459.03 34.1543C459.03 23.5025 454.34 18.0973 445.106 18.0973Z" fill="#499FDD"/>
                                                <path d="M341.189 46.3169C341.156 46.3581 336.241 51.537 329.77 51.537C323.875 51.537 317.919 47.922 317.919 39.8521C317.919 32.8848 322.537 28.0151 329.147 28.0151C331.294 28.0151 333.735 28.7838 334.117 30.0764L334.173 30.2946C335.053 33.2253 337.718 33.3824 338.242 33.3824L344.499 33.3892V27.9228C344.499 20.7125 335.322 18.0975 329.147 18.0975C315.941 18.0975 306.359 27.2863 306.359 39.9399C306.359 52.5886 315.837 61.7642 328.905 61.7642C340.243 61.7642 346.409 54.3159 346.467 54.2415L346.796 53.8382L341.841 45.6229L341.189 46.3169Z" fill="#499FDD"/>
                                            </g>
                                        </g>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_1_2">
                                            <rect width="460" height="78" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <div class="vendors-button" v-if="modalType === 'availability'" @click="goKayak(route.iata_from, route.iata_to, routeData.date_from, route.to, route.country_to, 'cheapflights')">
                                <svg height="30px" style="position:relative; top: 3px;" viewBox="0 0 511 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M46.9497 48.2634C44.3083 51.0144 38.7577 55.4086 27.9852 55.4086C12.5871 55.4086 0.5 45.1838 0.5 28.313C0.5 11.3812 12.6967 1.26604 28.0339 1.26604C38.8064 1.26604 44.6857 5.78194 46.0611 7.2061L42.2755 17.37C41.2774 16.0554 35.6781 11.8803 28.752 11.8803C19.8419 11.8803 13.0375 17.8082 13.0375 28.0939C13.0375 38.3674 20.1827 44.198 28.752 44.198C35.2886 44.198 40.0236 41.6174 42.872 38.6473L46.9497 48.2634Z" fill="#2B303D"/>
                                    <path d="M88.9324 54.4715H76.687V34.8009C76.687 30.2362 76.0784 26.2802 70.966 26.2802C65.8536 26.2802 64.259 30.5162 64.259 36.0667V54.4715H52.1111V2.0329H64.259V14.5217C64.259 18.3073 64.1972 22.4338 64.1972 22.4338C66.1327 19.0742 69.6992 16.3354 75.2497 16.3354C86.1318 16.3354 88.9315 23.2493 88.9315 32.3786L88.9324 54.4715Z" fill="#2B303D"/>
                                    <path d="M133.239 38.6473H106.582C107.13 44.0275 111.195 46.5107 116.149 46.5107C121.043 46.5107 125.267 44.3562 127.409 42.9321L132.193 49.2495C130.988 50.1867 126.033 55.36 114.384 55.36C102.845 55.36 94.3853 48.2148 94.3853 35.7869C94.3853 23.371 103.502 16.3354 114.604 16.3354C125.705 16.3354 133.41 23.6997 133.41 34.6304C133.41 36.4441 133.239 38.6473 133.239 38.6473ZM122.077 31.7699C122.033 28.3616 119.497 24.2475 114.384 24.2475C109.382 24.2475 106.801 28.2034 106.631 31.7699H122.077Z" fill="#2B303D"/>
                                    <path d="M172.654 54.4715H160.993L160.774 50.5154C159.179 52.11 156.16 55.2991 150.062 55.2991C143.465 55.2991 136.429 51.7326 136.429 43.3701C136.429 35.0199 144.122 32.2203 151.048 31.8795L160.506 31.5023V30.6747C160.506 26.7187 157.694 24.6859 152.813 24.6859C148.029 24.6859 143.245 26.8282 141.322 28.0333L138.133 20.1212C141.322 18.5267 147.202 16.3357 154.176 16.3357C161.163 16.3357 165.229 17.9181 168.199 20.669C171.108 23.42 172.703 27.0474 172.703 33.3648V54.4716L172.654 54.4715ZM160.555 37.99L154.566 38.3671C150.829 38.5376 148.626 40.1322 148.626 42.9318C148.626 45.841 150.999 47.5452 154.347 47.5452C157.645 47.5452 159.849 45.4029 160.555 44.1369V37.99Z" fill="#2B303D"/>
                                    <path d="M202.988 55.36C197.437 55.36 193.481 53.315 191.119 49.7972V68.2748H178.971V16.9927H190.511L190.458 21.7765H190.616C193.367 18.4778 197.384 16.2746 203.093 16.2746C213.865 16.2746 220.743 24.7344 220.743 35.7382C220.681 46.8394 213.87 55.36 202.988 55.36ZM199.47 25.8907C194.309 25.8907 190.73 29.8467 190.73 35.6164C190.73 41.3983 194.309 45.3544 199.47 45.3544C204.692 45.3544 208.319 41.3983 208.319 35.6164C208.319 29.8467 204.753 25.8907 199.47 25.8907Z" fill="#2B303D"/>
                                    <path d="M249.218 10.444C249.218 10.444 247.185 9.78678 244.872 9.78678C241.306 9.78678 240.369 11.8195 240.369 14.6801V17.1024H248.451V26.2803H240.369V54.4715H228.111V26.2803H223.327V17.1024H228.111V14.8991C228.111 11.1135 228.878 7.53484 231.081 5.06387C233.381 2.53203 236.96 1.04701 241.793 1.04701C246.296 1.04701 249.766 2.03301 249.766 2.03301L249.218 10.444Z" fill="#2B303D"/>
                                    <path d="M255.377 2.0329H267.513V54.5323H255.377V2.0329Z" fill="#2B303D"/>
                                    <path d="M280.708 12.6471C276.594 12.6471 273.782 10.1153 273.782 6.32965C273.782 2.59281 276.594 0 280.708 0C284.834 0 287.634 2.59281 287.634 6.32965C287.634 10.1761 284.834 12.6471 280.708 12.6471Z" fill="#2B303D"/>
                                    <path d="M274.658 16.9927H286.806V54.4715H274.658V16.9927Z" fill="#2B303D"/>
                                    <path d="M333.864 46.8881C333.864 54.9705 331.832 59.6445 328.143 63.1015C324.467 66.5706 319.465 69.0417 310.883 69.0417C302.204 69.0417 295.278 65.4143 292.697 63.4911L297.688 55.36C299.891 57.0033 305.612 59.5838 310.615 59.5838C315.618 59.5838 318.138 57.9892 319.464 56.6137C320.779 55.1895 321.765 52.4995 321.765 49.1399V47.9348H321.607C319.294 50.9048 315.667 53.2662 309.836 53.2662C300.658 53.2662 292.138 46.888 292.138 34.8009C292.138 22.7015 300.658 16.3354 309.836 16.3354C316.166 16.3354 319.732 19.2446 321.716 21.8251H321.875L321.716 17.0414H333.865L333.864 46.8881ZM313.354 25.842C307.974 25.842 304.505 29.798 304.505 34.9104C304.505 40.0715 307.913 44.0275 313.354 44.0275C318.746 44.0275 322.094 40.0715 322.094 34.9104C322.094 29.798 318.746 25.842 313.354 25.842Z" fill="#2B303D"/>
                                    <path d="M377.782 54.4715H365.524V34.8009C365.524 30.2362 364.916 26.2802 359.803 26.2802C354.691 26.2802 353.097 30.5162 353.097 36.0667V54.4715H340.948V2.0329H353.097V14.5217C353.097 18.3073 353.052 22.4338 353.052 22.4338C354.975 19.0742 358.542 16.3354 364.093 16.3354C374.975 16.3354 377.787 23.2493 377.787 32.3786L377.782 54.4715Z" fill="#2B303D"/>
                                    <path d="M407.848 26.2802H399.546V39.7428C399.546 42.932 399.984 43.6988 400.593 44.3562C401.141 44.9648 401.908 45.2934 403.502 45.2934C405.426 45.2934 407.13 44.6362 407.13 44.6362L407.738 54.1429C406.801 54.3619 403.502 55.3601 399.047 55.3601C394.702 55.3601 391.853 54.0333 389.93 51.8422C388.007 49.639 387.289 46.5108 387.289 40.7898V26.2804H381.957V17.1024H387.289V6.87769H399.546V17.0416H407.848V26.2802Z" fill="#2B303D"/>
                                    <path d="M438.291 52.0612C435.54 54.2036 431.803 55.36 426.8 55.36C421.201 55.36 415.261 53.595 410.976 49.5781L415.541 42.3843C418.56 44.9648 423.623 46.9489 426.642 46.9489C429.661 46.9489 431.803 46.1698 431.803 43.7597C431.803 41.3374 426.314 40.1324 424.938 39.6333C423.514 39.2561 421.359 38.6473 419.606 37.8804C417.841 37.1014 413.289 34.74 413.289 28.033C413.289 20.7296 419.655 16.2746 427.518 16.2746C435.382 16.2746 439.776 19.1837 441.918 20.8879L437.962 28.033C435.82 26.3897 431.584 24.4056 428.505 24.4056C425.595 24.4056 424.001 25.1847 424.001 27.1566C424.001 29.1407 426.922 30.0658 429.503 30.7839C432.083 31.5507 433.24 31.9404 434.834 32.549C436.477 33.1452 438.401 34.1435 439.727 35.3486C440.932 36.5536 442.746 38.976 442.746 42.9321C442.684 46.8394 441.042 49.858 438.291 52.0612Z" fill="#2B303D"/>
                                    <path d="M508.27 24.8925C505.3 23.7971 502.159 23.2371 498.97 23.298L490.948 23.3598L474.564 3.28759C474.187 2.84947 473.688 2.5818 473.092 2.5818H470.122C469.294 2.5818 468.685 3.45802 469.014 4.225L476.439 23.5182L464.571 24.2364L460.615 18.7953C460.116 18.0771 459.349 17.6875 458.521 17.6875H456.318C455.612 17.6875 455.113 18.4666 455.332 19.1726L458.193 28.4114L455.442 37.699C455.222 38.4171 455.722 39.184 456.428 39.184H458.679C459.507 39.184 460.274 38.7459 460.773 38.0884L464.62 32.5865L476.5 33.3532L469.403 52.7073C469.123 53.474 469.683 54.3505 470.56 54.3505H473.469C474.078 54.3505 474.564 54.0829 474.954 53.6447L491.009 33.3047L499.031 33.2429C502.159 33.2429 505.239 32.6467 508.148 31.5387C509.365 31.1006 510.302 30.0051 510.461 28.6904C510.68 26.9254 509.743 25.5011 508.27 24.8925Z" fill="#FFD400"/>
                                </svg>
                            </div>
                            <div class="vendors-button" v-if="modalType === 'cars'">
                                <svg height="26px" viewBox="0 0 188 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.00003 25C2.34409 25 3.66353 25 5.00003 25C5.00003 22.67 5.00003 20.3228 5.00003 18C10.0917 17.2667 13.5015 20.2085 14 25C15.6779 25 17.3306 25 19 25C17.9064 21.2815 14.333 18.0689 16.9437 13.7704C19.6409 7.49923 16.2878 0.868323 9.85241 0.565826C1.4111 1.28594 0.415415 7.33021 1.00003 14.0599C1.00003 17.7135 1.00003 21.3535 1.00003 25ZM5.00003 14C7.53073 13.9713 10.9219 14.3363 12.513 12.5316C14.2415 10.857 14.0788 7.96699 12.4539 6.29391C10.7164 4.08135 7.82782 4.2559 6.35479 6.42812C4.53767 8.46243 5.11526 11.393 5.00003 14ZM35 21C34.7835 18.0969 34.8115 14.5825 32.3351 11.6932C30.3003 8.63524 24.8925 8.77072 22.2545 10.4485C20.5597 11.2865 19.0644 13.6217 18.7689 16.088C17.6657 17.8383 20.3354 21.169 21.2621 22.4282C26.3889 27.7545 30.2975 22.6171 35 21ZM23 14.25C24.4541 15.6819 28.3497 14.7348 30 14.5C27.9537 11.9681 24.8229 12.0126 23 14.25ZM24 19.375C25.1575 21.2527 28.026 21.3193 29.5421 19.958C29.6947 19.8053 29.8474 19.6527 30 19.5C28.4549 18.661 25.9795 19.1724 24 19C24 19.1063 24 19.2487 24 19.375ZM36 25C37.3441 25 38.6635 25 40 25C40.2159 21.069 39.1288 14.509 43.4235 13.4999C47.8321 14.3137 46.7516 22.168 47 25C48.3441 25 49.6635 25 51 25C50.7487 21.201 51.5919 16.0684 49.0165 12.1175C46.726 8.70064 40.9316 7.95599 37.9396 12.052C35.2529 15.622 36.2003 21.1122 36 25ZM62 25C62 24.3361 62 23.6605 62 23C58.7842 20.3733 54.8584 18.7475 56 13C57.6779 13 59.3306 13 61 13C61 11.656 61 10.3365 61 9.00001C59.3222 9.00001 57.6694 9.00001 56 9.00001C56 7.65596 56 6.33652 56 5.00001C54.656 5.00001 53.3365 5.00001 52 5.00001C51.7327 12.2136 49.6957 25.6111 62 25ZM79 25C79.0302 20.5004 79.4124 15.3787 76.3187 11.6567C74.1783 8.42836 67.9549 8.50837 65.1805 11.5702C62.2549 14.3347 62.4118 20.4467 66.1815 23.1466C70.2092 25.7049 75.059 24.4125 79 25ZM67.1234 16.329C67.2226 18.7729 69.1761 21.5015 72.125 20.4496C73.8726 19.7968 75.1713 16.9445 74.2919 15.4058C73.4207 13.4683 70.9644 12.7035 69.048 13.3953C67.4243 13.6714 67.1324 14.6911 67.1234 16.329ZM80 25C81.3441 25 82.6635 25 84 25C84 17.3333 84 9.66144 84 2.00001C83.1675 2.00001 82.3296 2.00001 81.5 2.00001C79.2685 4.50935 80.2779 9.1567 80 12.97C80 16.9723 80 20.9983 80 25ZM101 21.5C99.9475 20.5484 98.5617 19.7355 97.5 19C95.5677 21.3225 90.0122 21.4538 90.4994 16.7576C90.4308 12.5675 95.6059 12.818 97.5 15C98.5001 13.9139 99.7334 13.2013 101 12.5C97.5886 8.72395 90.136 7.45177 87.0312 13.0496C84.9423 16.298 86.7467 22.5323 90.6385 23.99C95.1454 25.8481 98.1346 24.101 101 21.5ZM118 25C117.807 20.5912 118.673 14.5576 115.665 11.6343C113.051 8.6655 107.021 8.30749 104.181 11.5581C101.287 14.3509 101.38 20.4346 105.182 23.1466C109.209 25.7049 114.059 24.4125 118 25ZM106.123 16.329C106.221 19.581 108.756 21.1939 111.307 20.521C113.243 19.731 114.35 17.3437 113.37 15.4228C112.42 13.5214 110.011 12.6676 108.048 13.3952C106.424 13.6712 106.133 14.6913 106.123 16.329ZM119 25C120.344 25 121.664 25 123 25C123.096 21.8483 122.682 18.4786 124.058 15.5351C125.463 13.3483 128.899 12.2429 129 9.00001C122.346 8.18563 118.727 13.1319 119.029 19.0257C118.963 21.0126 119.027 23.0234 119 25ZM137 19C137 19.6639 137 20.3396 137 21C134.833 21.3591 130.764 20.9235 130 24C135.214 26.4091 142.56 23.6211 139.495 17.6893C138.24 16.256 136.075 15.1389 134 15C134 14.012 134 12.9793 134 12C135.171 12.0078 136.38 12.1954 137.5 13C138.683 11.8768 139.639 10.5912 140 9.00001C137.18 9.22677 133.345 8.58575 131.631 10.5747C129.215 12.146 130.761 15.7582 132.377 17.1816C133.497 18.3222 135.877 18.4945 137 19Z" fill="#00ADEF"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M143 25C144.005 25 144.995 25 146 25C146 23.6576 146 22.3311 146 21C145.001 21 143.991 21 143 21C143 22.3344 143 23.667 143 25ZM158 24C157.838 22.8232 157.309 21.8516 156.5 21C151.897 22.9494 149.845 19.2651 152.5 16C154.827 16.4162 157.115 16.9333 159 15.5C157.365 14.0636 154.995 13.0557 152.351 13.5725C149.864 13.7801 148.254 14.6702 148.414 17.015C147.762 20.1087 149.156 24.1306 152.444 24.5112C154.319 24.6248 156.193 24.5947 158 24ZM171 21C171.664 21 172.34 21 173 21C173 22.3441 173 23.6635 173 25C173.984 25 175.016 25 176 25C176 22.0101 176 18.9777 176 16C176.984 16 178.016 16 179 16C179 18.99 179 22.0224 179 25C179.984 25 181.016 25 182 25C182 22.0101 182 18.9777 182 16C182.984 16 184.016 16 185 16C185 18.99 185 22.0224 185 25C185.984 25 187.016 25 188 25C187.745 21.3698 188.67 16.473 186.079 14.2843C183.923 11.8773 178.636 14.1379 176.202 13.4682C174.663 13.5949 173.564 15.6497 173 17C172.336 17 171.66 17 171 17C170.471 14.0041 166.308 12.9602 163.792 13.7337C161.603 13.9082 160.405 14.946 160.243 16.9925C159.167 18.5488 159.219 19.5444 160.556 21.4068C162.389 24.7577 165.409 25.5214 168.521 23.8738C169.959 23.6331 170.652 22.2056 171 21ZM168 16C165.431 15.4733 161.71 16.8773 163.572 20.444C164.946 22.5093 167.344 21.6246 168.223 19.8904C168.981 18.7441 168.099 17.0617 168 16Z" fill="#006CA3"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M23 18.75C23.2633 19.6505 23.8255 20.3686 24.5 21C24.7224 20.3205 24.4008 19.924 24 19.5C27.3682 17.9115 31.956 20.9764 35 19.5C31.8835 17.0287 26.5702 18.4713 23 18C23 18.2551 23 18.499 23 18.75Z" fill="#9FE0F9"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M171 17.25C171.534 18.2034 172.08 19.3978 171 20.5C171.589 20.7685 172.245 20.9591 173 21C173 19.6673 173 18.3238 173 17C172.353 17 171.591 17 171 17C171 17.09 171 17.1733 171 17.25Z" fill="#BFDAE8"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M30 19.25C30.8047 20.457 33.3624 19.6053 34.5 21C34.7685 20.4109 34.9591 19.7548 35 19C33.3313 19 31.6628 19 30 19C30 19.09 30 19.1733 30 19.25Z" fill="#DFF5FD"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>


<style>
    .vendors-button {
        padding: 20px 20px;
        text-align: center;
        background-color: #f5f6f7;
        margin-top: 10px;
        border-radius: 10px;
        cursor: pointer;
    }
    .vendors-button:hover {
        background-color: #ebeced;
    }
  .btn-info {
      background-color: #17a2b8;
      color: #fff;
  }
  .btn-info:hover {
      background-color: #128294 !important;
      border-color: #128294 !important;
      color: #fff !important;
  }
  :root {
    --popper-theme-background-color: #333333;
    --popper-theme-background-color-hover: #333333;
    --popper-theme-text-color: #ffffff;
    --popper-theme-border-width: 0px;
    --popper-theme-border-style: solid;
    --popper-theme-border-radius: 6px;
    --popper-theme-padding: 10px;
    --popper-theme-box-shadow: 0 6px 30px -6px rgba(0, 0, 0, 0.25);
  }
</style>


<script>
import axios from "axios";
import {addDays, format, parse} from 'date-fns';
import Popper from "vue3-popper";

export default {
    name: "RouteItem",
    components: {
        Popper
    },
    props: {
        openAll: false,
        route: {
            required: true
        },
        maxDuration: {
            required: true
        },
        forceClose: {
            required: false
        },
        currentDate: {
            required: true
        },
    },

    computed: {
        nextDay() {
            let date = parse(this.currentDate, 'E dd MMM', new Date());
            date = addDays(date, 1);
            return format(date, 'MMM d')
        },
        flightstatus() {
            if (this.route.is_direct){
                return 'direct';
            }

            if (this.route.l1_airline.IATA === this.route.l2_airline.IATA) {
                return 'connection';
            }

            return 'other'
        }
    },
    data() {
      return {
          isOpen: false,
          loading: false,
          routeData: {},
          routeJson: '',
          modalType: '',
      }
    },
    created() {

    },
    mounted() {
        if(this.openAll) this.loadData(false);
    },
    watch: {
        forceClose(value) {
            if (value !== this.route.id) {
                this.isOpen = false;
            }
        }
    },
    methods: {
        goKayak(from, to, dateFrom, city, country, partner) {
            let alt, url;
            dateFrom = this.setToNowIfPast(this.convertToDate(this.currentDate));

            if(this.modalType === 'cars') {
                alt = 'cars';
                const altLocation = `${city},${country}`;
                url = `/outbound?alt=${alt}&alt-location=${altLocation}&partner=${partner}`;
            }
            else if(this.modalType === 'hotels') {
                alt = 'hotels';
                const altLocation = `${city},${country}`;
                url = `/outbound?alt=${alt}&alt-location=${altLocation}&partner=${partner}`;
            }
            else {
                alt = 'flights';
                url = `/outbound?from=${from}&to=${to}&flighttype=oneway&firstDate=${dateFrom}&label=route_page&alt=${alt}&partner=${partner}`;
            }
            window.open(url, '_blank');
        },
        goBooking(city, iata, dest_id) {
            let url = `https://www.booking.com/searchresults.html?ss=${city}&dest_id=${dest_id}&label=${iata}_flig.ht&aid=377127&dest_type=city`;
            window.open(url, '_blank');
        },
        setToNowIfPast(dateStr) {
            const today = new Date();
            const year = today.getFullYear();
            const month = (today.getMonth() + 1).toString().padStart(2, '0');  // Months are 0-based in JavaScript
            const day = today.getDate().toString().padStart(2, '0');

            const currentDate = `${year}-${month}-${day}`;
            if (dateStr < currentDate) {
                return currentDate;
            }

            return dateStr;
        },
        openModal(type) {
            if(type === 'hotels') {
                this.modalType = 'hotels';
            } else if(type === 'cars') {
                this.modalType = 'cars';
            } else if(type === 'availability') {
                this.modalType = 'availability';
            }
        },
        convertToDate(str) {
            // Get the current year
            const currentYear = new Date().getFullYear();

            // Extract day and month from the provided string
            const matches = str.match(/(\w{3}) (\d{1,2}) (\w{3})/);

            if (!matches) {
                throw new Error('Invalid date format');
            }

            const [, day, date, month] = matches;

            // Map the month name to its number
            const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            const monthNumber = monthNames.indexOf(month) + 1;

            if (monthNumber === -1) {
                throw new Error('Invalid month name');
            }

            // Return the formatted date
            return `${currentYear}-${monthNumber.toString().padStart(2, '0')}-${date.padStart(2, '0')}`;
        },
        isLowcost(route) {
            if (route.airline) {
                return parseInt(route.airline.is_lowcost) === 1
            }
            return route.l1_airline.is_lowcost === 1 || route.l2_airline.is_lowcost === 1;
        },
        isOverNight(route) {
            let start = route.departure_time.split(':');
            let end = route.arrival_time.split(':');
            let flag = (start[0] >= 23 && route.duration >= 300) || (end[0] <= 6 && route.duration >= 300);
            if (!flag) {
                if (!route.is_direct) {
                    let hoursstart = Math.floor(route.l1_flight_time / 60);
                    let hoursEnd = Math.floor(route.l2_flight_time / 60);
                    if ((parseInt(start[0]) + hoursstart - 23) >= 5) {
                        flag = true;
                    }
                    if (parseInt(end[0]) - hoursEnd <= 1 ) {
                        flag = true;
                    }
                }
            }
            return flag;

        },
        isFlightOvernight(start, end, duration) {
            return (parseInt(start[0]) >= 23 && duration >= 300) || (parseInt(end[0]) <= 6 && duration >= 300);
        },
        convertMinutesToTime(minutes, separator = '') {
            const hours = Math.floor(minutes / 60);
            let remainingMinutes = minutes % 60;
            if (remainingMinutes < 10) {
                remainingMinutes = '0'+remainingMinutes;
            }
            return hours + "h" + separator + remainingMinutes + "m";
        },
        convertMinutesToTimeLong(minutes, separator = '') {
            const hours = Math.floor(minutes / 60);
            let remainingMinutes = minutes % 60;
            if (remainingMinutes < 10) {
                remainingMinutes = '0'+remainingMinutes;
            }
            return hours + " hours " + separator + remainingMinutes + " minutes";
        },
        convertTime(time) {
            const splitTime = time.split(":");
            return splitTime[0]+':'+splitTime[1];
        },
        calculateWidth(current) {
            return (current/this.maxDuration) * 100;
        },
        toggleOpen() {
            if (this.isOpen) {
                this.isOpen = false;
                this.$emit('open', {id: null});
            } else {
                this.loadData();
            }
        },
        loadData(showLoading = true){
            // if(closeOthers) this.$emit('open', {id: this.route.id});
            if(showLoading) this.loading = true;
            this.$nextTick(() => {
                const yOffset = -85;
                let y = this.$refs['item-'+ this.route.id].getBoundingClientRect().top + window.pageYOffset + yOffset;
                // window.scrollTo({top: y, behavior: "smooth" })

                const prefix = this.route.is_direct ? 'direct' : 'connect';

                axios.get(`/api/route/${prefix}/${this.route.id}/more-info`).then((res) => {
                    this.routeData = res.data.routeData;
                    this.routeJson = res.data.routeJson;
                    this.isOpen = true;
                    this.loading = false;
                });
            });
        },
        showChangeTerminal() {
            if (!this.routeData.is_direct) {
                return (
                    this.routeData.l1_arrival_terminal !== '' &&
                    this.routeData.l2_departure_terminal !== '' &&
                    this.routeData.l1_arrival_terminal !== this.routeData.l2_departure_terminal
                );
            }

            return false;
        },
        isArrivesNextDay() {
            let departure = this.routeData.departure_time.split(':');
            let time = (parseInt(departure[0]) * 60) + this.routeData.l1_flight_time;
            if (time > 1440) {
                return true;
            }

            return false;
        }
    }
}
</script>

<style scoped>

</style>
